module.exports = require('./dist/node/entry/index-live-query');



//////////////////
// WEBPACK FOOTER
// ./~/leancloud-storage/live-query.js
// module id = 16
// module chunks = 0